// Chunked OTA protocol introduced June 2026 — devices flashed before this need one USB flash.
export const CHUNKED_OTA_AVAILABLE_SINCE = 'June 2026';

export const OTA_MIGRATION_DISMISS_KEY = 'garden-sync:ota-migration-dismissed';